import getData from "@/__main__/get-data.mjs";
import { appURLs } from "@/app/constants.mjs";
import {
  QUEUE_SYMBOLS,
  RANK_SYMBOL_TO_STR,
  RANK_SYMBOLS,
  ROLE_SYMBOL_TO_STR,
} from "@/game-lol/constants/constants.mjs";
import * as GraphQLTemplatesDatalake from "@/game-lol/graphql-templates-datalake.mjs";
import ChampionByDurationStats from "@/game-lol/models/lol-champion-by-duration-stats.mjs";
import QueueSymbol, {
  QUEUE_SYMBOL_TO_OBJECT,
} from "@/game-lol/utils/symbol-queue.mjs";
import { RankSymbol } from "@/game-lol/utils/symbol-rank.mjs";
import RoleSymbol from "@/game-lol/utils/symbol-role.mjs";
import { coachingStatsKey } from "@/game-lol/utils/util.mjs";
import { queryGQL } from "@/util/gql-formatters.mjs";

// Champion by-duration stats
// Singular  (one champion)
// State location: ["lol", "championStatsByDuration", coachingStatsKey(statsVariables)]

function queryChampionByDurationStats(variables: {
  queue: string;
  championId: number;
  tier?: symbol;
  role: symbol;
}) {
  const params = {
    queue: variables.queue,
    championId: `${variables.championId}`,
    tier: variables.tier
      ? RANK_SYMBOL_TO_STR[RankSymbol(variables?.tier)]?.gql
      : RANK_SYMBOL_TO_STR[RANK_SYMBOLS.platinum].gql,
    role: ROLE_SYMBOL_TO_STR[RoleSymbol(variables?.role)]?.gql,
  };

  if (QueueSymbol(params.queue) === QUEUE_SYMBOLS.aram) {
    delete params.tier;
    delete params.role;
  }

  return queryGQL(
    appURLs.DATALAKE,
    GraphQLTemplatesDatalake.ChampionByDurationStats,
    params,
  );
}

export default function (
  statsVariables: {
    queue?: string;
    championId: number;
    tier: string;
    role: string;
  },
  options = {},
) {
  const convertedVariables = {
    queue:
      statsVariables.queue ||
      QUEUE_SYMBOL_TO_OBJECT[QUEUE_SYMBOLS.rankedSoloDuo].gql,
    championId: statsVariables.championId,
    tier: statsVariables.tier ? RankSymbol(statsVariables.tier) : undefined,
    role: RoleSymbol(statsVariables.role),
  };

  return getData(
    queryChampionByDurationStats(convertedVariables),
    ChampionByDurationStats,
    ["lol", "championStatsByDuration", coachingStatsKey(convertedVariables)],
    {
      ...options,
      // shouldFetchIfPathExists: false,
      // expiryTime: Date.now() + 2 * 60 * 60 * 1000, // 12 hours
    },
  );
}
